import {graphql} from 'react-relay'

export const query = graphql`
  query PipelinePageQuery($locator: String!) {
    pipeline(pipelineLocator: $locator) {
      ...PipelinePageFragment
    }
  }
`
